module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0142.jpg?v=1b496649";